import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'next-i18next';
import { TermsType } from 'typings/markets/api';
import Spacer from '@/components/ui-components/Spacer';
import SecurityCard from './SecurityCard';
import Typography from '../../components/Typography';

const useStyles = makeStyles((theme) => ({
  root: {},
  conversionArrowGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrowDivXs: {
    marginBottom: theme.spacing(0.5),
  },
}));

interface Props {
  terms: TermsType
  currency: string
}

const defaultProps = {};

const Terms = ({
  terms, currency,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation('markets');
  const xs = useMediaQuery(theme.breakpoints.down('xs'));
  const md = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Typography variant="header">
        {t('markets.detailView.terms.title')}
      </Typography>
      <Spacer spacing={2} />
      <Grid
        container
        direction="row"
        justify={(terms.converts_to && terms.converts_to.name !== undefined && terms.converts_to.name !== 'UNKNOWN' && terms.converts_to.name !== 'OTHER') ? 'center' : 'flex-start'}
        alignItems="stretch"
        alignContent="center"
      >
        <Grid item xs={12} sm={5}>
          <SecurityCard term={terms.standard} name={terms.standard.name!} currency={currency} />
        </Grid>

        {(terms.converts_to && terms.converts_to.name !== undefined && terms.converts_to.name !== 'UNKNOWN' && terms.converts_to.name !== 'OTHER') && (
          <Grid item xs={12} sm={2} className={classes.conversionArrowGrid}>
            {md && <Spacer spacing={2} />}
            <Typography variant="secondary2bold">
              {t('markets.detailView.terms.convertsTo')}
            </Typography>
            {md && <Spacer spacing={1} />}
            {xs ? (
              <div className={classes.arrowDivXs}>
                <svg
                  width="17"
                  height="33"
                  viewBox="0 0 17 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5416 24.6872L10.5416 0.166748L6.45829 0.166748L6.45829 24.6872H0.333292L8.49996 32.8334L16.6666 24.6872H10.5416Z"
                    fill="#292D44"
                  />
                </svg>
              </div>
            ) : (
              <svg
                width="33"
                height="17"
                viewBox="0 0 33 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.6871 6.45825H0.166672V10.5416H24.6871V16.6666L32.8333 8.49992L24.6871 0.333252V6.45825Z"
                  fill="#292D44"
                />
              </svg>
            )}
            {md && <Spacer spacing={2} />}
          </Grid>
        )}
        {(terms.converts_to && terms.converts_to.name !== undefined && terms.converts_to.name !== 'UNKNOWN' && terms.converts_to.name !== 'OTHER') && (
          <Grid item xs={12} sm={5}>
            <SecurityCard
              term={terms.converts_to!}
              name={terms.converts_to.name!}
              currency={currency}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

Terms.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default Terms;
